<template>
  <div class="tree_node" :title="node.data.label">
    <div class="icon">
      <i
        v-show="!node.data.isLeaf"
        :class="['el-icon-caret-right', 'icon-inner', { expanded: node.expanded }]"
      ></i>
    </div>
    <img :src="iconPath" :width="node.data.logoSize || 18"
      :height="node.data.logoSize || 18"
      style="display: inline-block; margin-right: 5px"/>
    <span class="text">{{ node.data.label }}</span>
  </div>
</template>

<script>
export default {
  name: 'TreeNode',

  props: {
    node: {
      type: Object,
      required: true
    }
  },
  computed: {
    iconPath() {
      return require(`@/assets/img/${this.node.data.logo}.png`);
    }
  }
};
</script>

<style scoped lang="scss">
.tree_node {
  width: 100%;
  height: 26px;
  font-size: 13px;
  display: flex;
  align-items: center;

  .icon {
    width: 28px;
    display: flex;
    align-items: center;
    justify-content: center;

    &-inner {
      cursor: pointer;
      color: #c0c4cc;
      font-size: 12px;
      transform: rotate(0deg);
      transition: -webkit-transform 0.3s ease-in-out;
      transition: transform 0.3s ease-in-out;
    }

    .expanded {
      transform: rotate(90deg);
    }
  }

  .logo {
    margin-right: 6px;
  }
}
</style>
